import { Map as ImmutableMap } from 'immutable';
import { buildTypedMap } from '../types/TypedMap';
import { DEALS_FETCH_FAILED, DEALS_FETCH_STARTED, DEALS_FETCH_SUCCEEDED, SAVE_DEALS_UPDATES, SET_DEAL_COLUMN_WIDTH, SET_DEAL_TABLE_PAGINATION, SET_DEAL_TABLE_SORT, SET_SHOW_SUBMISSION_PANEL_FROM_DEAL_TABLE, SET_SELECTED_DEAL_AMOUNT, SET_SELECTED_DEAL_COUNT, SET_SELECTED_DEAL_IDS } from '../actions/ActionTypes';
import { FAILED, STARTED, SUCCEEDED, UNINITIALIZED } from '../constants/RequestStatusTypes';
import { DEFAULT_PAGINATION_STATE, DEFAULT_SORT_STATE } from '../constants/CrmSearchConstants';
const initialState = buildTypedMap({
  dealColumnWidths: {},
  deals: ImmutableMap(),
  selectedDealAmount: {
    value: 0,
    currencyCode: ''
  },
  selectedDealCount: undefined,
  selectedDealIdsByForecastType: {},
  showSubmissionPanelFromDealTable: false,
  status: UNINITIALIZED,
  total: 0,
  totalDealAmount: {
    value: 0,
    currencyCode: ''
  },
  totalOrWeightedDealAmount: {
    value: 0,
    currencyCode: ''
  },
  pagination: DEFAULT_PAGINATION_STATE,
  sort: {
    state: DEFAULT_SORT_STATE,
    isDefault: true
  }
});
export default function deals(state = initialState, action) {
  switch (action.type) {
    case DEALS_FETCH_STARTED:
      return state.merge({
        status: STARTED
      });
    case DEALS_FETCH_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state
        // using .set instead of .merge here ensures POJOs
        // aren't converted into Immutable Maps
        .set('deals', payload.deals).set('total', payload.total).set('status', SUCCEEDED).set('totalDealAmount', payload.totalDealAmount).set('totalOrWeightedDealAmount', payload.totalOrWeightedDealAmount);
      }
    case DEALS_FETCH_FAILED:
      {
        return state.merge({
          status: FAILED
        });
      }
    case SAVE_DEALS_UPDATES:
      {
        const {
          payload
        } = action;
        let allDeals = payload.deals;
        const stagedDealsUpdates = payload.dealsUpdates || {};
        for (const [dealId, propertyUpdates] of Object.entries(stagedDealsUpdates)) {
          const dealToUpdate = allDeals.get(Number(dealId));
          // Changes might be on multiple pages, but we only want to update deals in redux on the current page
          if (dealToUpdate) {
            const formattedPropertyUpdates = {};
            Object.keys(propertyUpdates).forEach(key => {
              formattedPropertyUpdates[key] = {
                value: propertyUpdates[key]
              };
            });

            //Ensures that we deep clone
            const updatedDeal = Object.assign({}, dealToUpdate, {
              properties: Object.assign({}, dealToUpdate === null || dealToUpdate === void 0 ? void 0 : dealToUpdate.properties, formattedPropertyUpdates)
            });
            allDeals = allDeals.set(Number(dealId), updatedDeal);
          }
        }
        return state.merge({
          deals: allDeals
        });
      }
    case SET_SHOW_SUBMISSION_PANEL_FROM_DEAL_TABLE:
      {
        const {
          payload
        } = action;
        return state.merge({
          showSubmissionPanelFromDealTable: payload
        });
      }
    case SET_SELECTED_DEAL_AMOUNT:
      {
        const {
          payload
        } = action;
        return state.set('selectedDealAmount', payload);
      }
    case SET_SELECTED_DEAL_COUNT:
      {
        const {
          payload
        } = action;
        return state.set('selectedDealCount', payload);
      }
    case SET_SELECTED_DEAL_IDS:
      {
        const {
          payload
        } = action;
        return state.set('selectedDealIdsByForecastType', Object.assign({}, state.get('selectedDealIdsByForecastType'), {
          [payload.forecastTypeId]: payload.dealIds
        }));
      }
    case SET_DEAL_COLUMN_WIDTH:
      {
        const {
          payload
        } = action;
        return state.set('dealColumnWidths', Object.assign({}, state.get('dealColumnWidths'), {
          [payload.columnName]: payload.width
        }));
      }
    case SET_DEAL_TABLE_PAGINATION:
      {
        const {
          payload
        } = action;
        return state.set('pagination', payload);
      }
    case SET_DEAL_TABLE_SORT:
      {
        const {
          payload
        } = action;
        return state.set('sort', payload);
      }
    default:
      return state;
  }
}